import AppServices from "./appservices";

class RateService extends AppServices {

  sendEvaluation( form = {} ) {
    return this.request("/evaluation", "POST", form);
  }
}

export default RateService;